const APP_CONFIG = {
  FRONTEND_VERSION: 45,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
